import React from 'react';
import { Table, Button, Space, Tag, Avatar } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { format } from 'date-fns';

const IndustryTable = ({ industries, onEdit, onDelete }) => {
  if (!industries || industries.length === 0) {
    return null; // Handled by parent component
  }

  const columns = [
    {
      title: <span style={{ fontFamily: 'Rubik, sans-serif', fontSize: '16px', fontWeight: 400, color: '#470172' }}>Industry</span>,
      key: 'industry',
      render: (_, industry) => {
        const sectorName = industry?.sectorName || industry?.name || 'Unknown Sector';
        const firstLetter = sectorName.charAt(0).toUpperCase();
        
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <Avatar 
              size={40} 
              style={{ 
                backgroundColor: '#e6d5f0', 
                color: '#470172',
                fontFamily: 'Rubik, sans-serif',
                fontSize: '18px',
                fontWeight: 500
              }}
            >
              {firstLetter}
            </Avatar>
            <div>
              <div style={{ fontFamily: 'Rubik, sans-serif', fontSize: '16px', fontWeight: 400, color: '#470172' }}>
                {sectorName}
              </div>
              <div style={{ fontFamily: 'Rubik, sans-serif', fontSize: '14px', fontWeight: 400, color: '#8b8b8b' }}>
                {industry?.briefDescription?.substring(0, 60) || 'No description'}...
              </div>
            </div>
          </div>
        );
      },
    },
    {
      title: <span style={{ fontFamily: 'Rubik, sans-serif', fontSize: '16px', fontWeight: 400, color: '#470172' }}>Convener Members</span>,
      key: 'chairMembers',
      responsive: ['md'],
      render: (_, industry) => (
        <span style={{ fontFamily: 'Rubik, sans-serif', fontSize: '16px', fontWeight: 400, color: '#470172' }}>
          {Array.isArray(industry?.chairCoChairMembers) 
            ? `${industry.chairCoChairMembers.length} member${industry.chairCoChairMembers.length !== 1 ? 's' : ''}`
            : '0 members'
          }
        </span>
      ),
    },
    {
      title: <span style={{ fontFamily: 'Rubik, sans-serif', fontSize: '16px', fontWeight: 400, color: '#470172' }}>Created</span>,
      key: 'created',
      responsive: ['lg'],
      render: (_, industry) => (
        <span style={{ fontFamily: 'Rubik, sans-serif', fontSize: '16px', fontWeight: 400, color: '#470172' }}>
          {industry?.createdAt ? format(new Date(industry.createdAt), 'MMM d, yyyy') : '—'}
        </span>
      ),
    },
    {
      title: <span style={{ fontFamily: 'Rubik, sans-serif', fontSize: '16px', fontWeight: 400, color: '#470172' }}>Actions</span>,
      key: 'actions',
      align: 'right',
      render: (_, industry) => (
        <Space size="small">
          <Button
            type="text"
            icon={<EditOutlined />}
            onClick={() => onEdit(industry)}
            style={{
              fontFamily: 'Rubik, sans-serif',
              fontSize: '16px',
              fontWeight: 400,
              color: '#470172',
            }}
            title="Edit"
          />
          <Button
            type="text"
            danger
            icon={<DeleteOutlined />}
            onClick={() => onDelete(industry._id)}
            style={{
              fontFamily: 'Rubik, sans-serif',
              fontSize: '16px',
              fontWeight: 400,
            }}
            title="Delete"
          />
        </Space>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={industries}
      rowKey="_id"
      pagination={{
        pageSize: 10,
        showSizeChanger: true,
        showTotal: (total) => (
          <span style={{ fontFamily: 'Rubik, sans-serif', fontSize: '16px', fontWeight: 400, color: '#470172' }}>
            Total {total} items
          </span>
        ),
        style: { fontFamily: 'Rubik, sans-serif', fontSize: '16px', fontWeight: 400 }
      }}
      style={{ fontFamily: 'Rubik, sans-serif' }}
      locale={{
        emptyText: (
          <span style={{ fontFamily: 'Rubik, sans-serif', fontSize: '16px', fontWeight: 400, color: '#470172' }}>
            No industries found
          </span>
        )
      }}
      rowClassName={() => 'hover:bg-gray-50'}
    />
  );
};

export default IndustryTable;
